import { gql } from '@apollo/client';

export const GET_PATIENT_DRAFT_EXAMS = gql`
  query GetPatientDraftExams($examsFilter: FilterFindManyExamInput!) {
    exams(filter: $examsFilter, sort: CREATED_AT_DESC) {
      _id
      examDate
      technology
      device
      priority
      user {
        firstName
        lastName
        firebaseId
        institution {
          _id
        }
      }
      physician {
        _id
      }
      medicalNotes {
        _id
        user {
          _id
          firstName
          lastName
        }
        content
        creationDate
      }
      clinicalIndication
      models
      status
      media {
        fullVideo
        frames
      }
    }
  }
`;

export const CREATE_EXAM = gql`
  mutation CreateExam($record: CreateOneExamInput!) {
    createExam(record: $record) {
      record {
        _id
        user {
          _id
          institution {
            _id
          }
        }
        physician {
          _id
        }
        patient {
          _id
        }
        technology
        device
        models
        status
      }
    }
  }
`;

export const REMOVE_EXAM = gql`
  mutation RemoveExam($removeExamId: MongoID!) {
    removeExam(_id: $removeExamId) {
      record {
        _id
      }
    }
  }
`;

export const GET_PATIENT_BY_ID = gql`
  query PatientById($id: MongoID!) {
    patient(filter: { _id: $id }) {
      firstName
      lastName
      avatar
    }
  }
`;

export interface IPatientProfile {
  patient: {
    firstName: string;
    lastName: string;
    avatar: string;
  };
}
